
import { formatPrice } from '@artmizu/utils';
import { computed } from '@vue/composition-api';
import type { ProductExtended } from '~/type/product/Product';
const __sfc_main = {};
__sfc_main.props = {
  product: {
    key: "product",
    required: true,
    type: null
  },
  loading: {
    key: "loading",
    required: false,
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const isLoading = computed(() => props.loading);
  const downPayment = computed(() => {
    const price = props.product.price?.common.value ?? 0;
    const percent = price >= 3000 && price < 110000 ? 30 : 45;
    const value = price * percent / 100;
    return {
      value: Math.ceil(value / 10) * 10,
      percent
    };
  });
  function onEnable() {
    if (!isLoading.value) emit('enable');
  }
  return {
    formatPrice,
    isLoading,
    downPayment,
    onEnable
  };
};
export default __sfc_main;
